import {InputTypes} from "../InputTypes";
import {OptionsSources} from "../OptionsSources";

export const Admin = Object.freeze({
    name: {
        visibleName: "Nombre",
        type: InputTypes.TEXT,
    },
    last_name: {
        visibleName: "Apellido",
        type: InputTypes.TEXT,
    },
    email: {
        visibleName: "Email",
        type: InputTypes.EMAIL,
    },
    super: {
        visibleName: "Super-Admin",
        type: InputTypes.SELECT,
        optionsMapping: {
            source: OptionsSources.BOOLEAN
        }
    },
    timestamp: {
        visibleName: "Fecha de creación",
        nonEditable: true,
        type: InputTypes.DATE,
    },
    validated: {
        hidden: true,
        type: InputTypes.SELECT,
        optionsMapping: {
            source: OptionsSources.BOOLEAN
        }
    },
    password: {
        visibleName: "Contraseña",
        hidden: true,
        type: InputTypes.PASSWORD,
    },
    passwordVerification: {
        visibleName: "Repetir contraseña",
        hidden: true,
        type: InputTypes.PASSWORD,
    },
})